export const removeLoadingScreen = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const loadingScreenElement = (document as any).getElementById("loading-screen");
  if (loadingScreenElement) loadingScreenElement.parentNode.removeChild(loadingScreenElement);
};
